import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { wv_willfade, wv_willtransform, wv_imgheight } from "./../styles"

export const SWAP_DURATION = 400
export const UPDATE_DURATION = 400

export const wv_imgscale = css`
  position: relative;
  height: 100%;
  transform-origin: var(--wv-cover-transform-origin);
  ${wv_willtransform(`translate(0%, var(--wv-cover-translate-Y)) scale(var(--wv-cover-scale)) translateZ(0)`, `translate(0%,0%) scale(1) translateZ(0)`)}
`

export const MainToggle = styled.section`
  --shadow-ratio: 1380 / 1180;
  --wv-roller-swap-duration: ${SWAP_DURATION}ms;
  position: relative;
  height: 100%;
  width: 100%;

  display: flex;
  justify-content: center;

  z-index: 1;
  pointer-events: none;

  & figure:nth-of-type(1) {
    display: none;
  }
`

export const Main = styled.section`
  --shadow-ratio: 1380 / 1180;
  --wv-roller-swap-duration: ${SWAP_DURATION}ms;
  ${wv_willfade}
  position: relative;
  ${wv_imgheight}

  display: flex;
  justify-content: center;

  z-index: 1;
  pointer-events: none;

  .wv_ref & {
    pointer-events: auto;
    cursor: pointer;
  }

  &.wv_straight {
    --wv-roller-swap-duration: 0ms;
  }
  & > div {
    ${wv_imgscale}

    & figure {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      will-change: opacity;

      animation-fill-mode: both;
      animation-name: wvwrfadeout;
      animation-duration: 0ms;
      animation-timing-function: cubic-bezier(0.61, 1, 0.88, 1);
      animation-delay: var(--wv-roller-swap-duration);

      &.wv_reveal {
        animation-name: wvwrfadein;
        animation-duration: var(--wv-roller-swap-duration);
        animation-delay: 0ms;
      }

      &:nth-of-type(1) {
        position: relative;
        opacity: 1;
        animation: none;
        height: calc(100% * var(--shadow-ratio));
      }

      @keyframes wvwrfadein {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }

      @keyframes wvwrfadeout {
        0% {
          opacity: initial;
        }
        100% {
          opacity: 0;
        }
      }

      img {
        -webkit-user-drag: none;
        pointer-events: none;
        position: relative;
        object-fit: cover;
        height: 100%;
        width: auto;
      }
    }
  }
`
